import { h } from "preact";
import { RoutableProps } from "preact-router";
import { useEffect, useState } from "preact/hooks";
import { ApiError, approveOrder, getOrderInfo, getProductTypes, ManufacturingOrder, ManufacturingOrderRevision, ProductType } from "../../api/product-api";
import { route } from "../../App";
import { Snackbar, SnackbarShowCommand } from "../../components/Snackbar";
import { useCommand } from "../../hooks";
import { parseToDateAndFormatIfExists, trimText } from "../../utils";
import "./styles.scss";

export function ProductTypeList(props: RoutableProps) {
    const [productTypes, setProductTypes] = useState(null as null | ProductType[]);
    const [ordersSearch, setOrdersSearch] = useState("");
    const showSnackbarCommand = useCommand<SnackbarShowCommand>();

    useEffect(() => {
        getProductTypes().then(async (products) => {
            setProductTypes(products);
        });
    }, []);

    if (!productTypes) {
        return <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%">
            <div>Pobieranie danych...</div>
            <div class="loader"></div>
        </div>;
    }

    return <div class="product-list-page">
        <Snackbar doShow={showSnackbarCommand}/>
        {productTypes ? [
            <h1>Rodzaje produktów</h1>,
            <div class="order-items paper">
                <div class="search">
                    <input class="search-text" placeholder="Wyszukaj..." onInput={(e) => setOrdersSearch(e.currentTarget.value)}/>
                    <button type="button" onClick={() => route("/product-type/new")} class="ml-2.5">Utwórz nowy rodzaj produktu</button>
                </div>

                <table class="orders list selectable" style="margin-bottom: 10px;">
                    <thead>
                        <tr>
                            <th class="header">Id</th>
                            <th class="header">Nazwa</th>
                            <th class="header">Brand</th>
                            <th class="header">Rejestrujący</th>
                            <th class="header">Data rejestracji</th>
                            <th class="header">Aktualna rewizja</th>
                            <th class="header">Rodzaj numeru seryjnego</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productTypes.filter(item => !ordersSearch
                                || item.name.toLowerCase().indexOf(ordersSearch.toLowerCase()) >= 0
                                || item.brand.toLowerCase().indexOf(ordersSearch.toLowerCase()) >= 0
                                || item.creator.email.toLowerCase().indexOf(ordersSearch.toLowerCase()) >= 0
                                || parseToDateAndFormatIfExists(item.createdAt).toLocaleString().indexOf(ordersSearch) >= 0)
                                .map((item) => [
                            <tr onClick={() => route("/product-type/" + item.id)}>
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                                <td>{item.brand}</td>
                                <td>{item.creator.email}</td>
                                <td>{parseToDateAndFormatIfExists(item.createdAt)}</td>
                                <td><button type="button" style="height: 20px; text-transform: initial; font-weight: initial; font-size: 14px;" class="flat borderless" onClick={(e) => {
                                    route("/product-type-revision/" + item.currentProductTypeRevision?.id);
                                    e.stopPropagation();
                                }}>{item.currentProductTypeRevision?.name ? item.currentProductTypeRevision?.name : `<ID: ${item.currentProductTypeRevision?.id}>`}</button></td>
                                <td>{item.serialNumberType?.name}</td>
                                <td></td>
                            </tr>
                        ])}
                    </tbody>
                </table>
            </div>
        ] : null}
    </div>;
}
